import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FirebaseService } from 'app/services/firebase.service';

@Component({
  selector: 'designing-tutorial',
  styleUrls: ['../designing.component.scss', './tutorial.component.scss'],
  templateUrl: './tutorial.component.html',
})
export class DesigningTutorialComponent {
  @Input() step;
  @Input() totalSteps;
  @Input() projectId;
  @Input() storyId;
  @Output() next = new EventEmitter();
  @Output() prev = new EventEmitter();
  // submitTimeout;

  constructor(
    public translate: TranslateService,
    public firebaseService: FirebaseService
  ) {}

  submit(animationSkipped) {

    if (animationSkipped) {
      this.firebaseService.logEvent('design_request_animation_skip', {
        story_id: this.storyId,
        project_id: this.projectId,
        skipped_screen: this.step
      });
      this.firebaseService.logEvent('design_request_animation_next', {
        story_id: this.storyId,
        project_id: this.projectId
      });
    } else {
      this.firebaseService.logEvent('design_request_animation_finish', {
        story_id: this.storyId,
        project_id: this.projectId
      });
    }
    this.next.emit();
  }
  // setSubmitTimer() {
  //   this.submitTimeout = setTimeout(() => {
  //     this.submit();
  //   }, 40000);
  // }

  // ngOnDestroy() {
  //   clearTimeout(this.submitTimeout);
  // }
}
